import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface globalSettingsState {
  width: number;
  height: number;
  isMobile: boolean;
}

const initialState: globalSettingsState = {
  width: 0,
  height: 0,
  isMobile: false,
};

export const counterSlice = createSlice({
  name: 'globalSettings',
  initialState,
  reducers: {
    setGlobalSetting: (state, action: PayloadAction<globalSettingsState>) => {
      state.width = action.payload.width;
      state.height = action.payload.height;
      state.isMobile = action.payload.isMobile;
    },
  },
});

export const { setGlobalSetting } = counterSlice.actions;

export const getGlobal = (state: RootState) => state.global;

export const globalReducer = counterSlice.reducer;
